import { PaymentIntent } from '@stripe/stripe-js';
import { PurchaseSession } from '../types/stripe';
import { CalendarDate, SubsctiptionType, TraitData } from '../types/common';
import { NAME_KEYWORD_PREFIX, SURNAME_KEYWORD_PREFIX } from '../constants/utils';
import { CareGiver, CareGiverPeronality } from '../types/caregivers';
import { Family } from '../types/families';
import jsPDF from 'jspdf';
import { getCalculationResultRange } from '../service/calculation';
import autoTable, { RowInput } from 'jspdf-autotable'
import { formaTimestampTo_DD_MM_YY } from './date';
import logo from "../assets/logoForPdf/image.png";
import { getUserFamily } from '../service/families';
import { Calculation } from '../types/calculation';
import { getUserCaregiver } from '../service/caregiovers';
import { CAREGIVER_COVERAGE_AVAILABILITY, CAREGIVER_OTHER_PEOPLE_PRESENCE, CAREGIVER_PERSONALITIES_POSITIVENESS, CAREGIVER_SMOKES, CAREGIVER_WEEKEND_AVAILABILIY, CAREGIVERS_NIGHT_TIME } from '../constants/caregivers';

export function brkRef<T>(
  data: T
): T {
  return JSON.parse(JSON.stringify(data));
}

export function formatDate(
  date: number | Date
): string {
  const _date = typeof date === 'number' ? new Date(date) : date;
  let day = getTwoDigitsNumber(_date.getDate());
  let month: number | string = getTwoDigitsNumber(_date.getMonth() + 1);
  return day + "/" + month + "/" + _date.getFullYear();
}

export function getTwoDigitsNumber(number: number) {
  const stringNumber = JSON.stringify(number);
  if (stringNumber.length === 1) return '0' + stringNumber;
  return stringNumber;
} 

export function filterPendingTantumPayments(
  intents: PaymentIntent[]
): PaymentIntent[] {
  return intents.filter(intent => intent.status !== 'succeeded' && intent.status !== 'canceled');
}

export function filterPendingSubscriptions(
  subscriptions: any[]
): any[] {
  return subscriptions.filter(sub => sub.status === 'incomplete');
}

export function calendarDate2Timestamp(
  calendarDate: CalendarDate
): number {
  const { day, month, year } = calendarDate;
  const date = new Date(year, month - 1, day);
  return date.getTime();
}

export function ts2Age(
  timestamp: number,
): number {
  const now = new Date();
  const birthDate = new Date(timestamp);
  let age = now.getFullYear() - birthDate.getFullYear();
  const month = now.getMonth() - birthDate.getMonth();
  if (month < 0 || (month === 0 && now.getDate() < birthDate.getDate())) age--;
  return age;
}

export function timestamp2CalendarDate(
  timestamp: number
): CalendarDate {
  const date = new Date(timestamp);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return { day, month, year };
}

export function getStringKeywords(
  name: string,
  surname: string,
): string[] {
  const _name = name.toLowerCase();
  const _surname = surname.toLocaleLowerCase();
  const nameKeywords: string[] = [];
  const surnameKeywords: string[] = [];
  const keywords: string[] = [];
  for (let i = 1; i <= _name.length; ++i) {
    let partial = _name.slice(0, i);
    nameKeywords.push(partial);
    keywords.push(partial);
  }
  for (let i = 1; i <= _surname.length; ++i) {
    let partial = `/${_surname.slice(0, i)}`;
    surnameKeywords.push(partial);
    keywords.push(partial);
  }
  for (let i = 0; i < nameKeywords.length; ++i) {
    const nameEl = nameKeywords[i];
    for (let j = 0; j < surnameKeywords.length; ++j) {
keywords.push(`${nameEl}${surnameKeywords[j]}`);
    }
  }
  return keywords;
}

export function getPositiviePersonalitiesMetadata(
  c_personalities: CareGiverPeronality[]
): number {
  let positiviePersonalities = 0;
  for (let p of c_personalities) {
    if (CAREGIVER_PERSONALITIES_POSITIVENESS[p]) positiviePersonalities++;
  }
  return positiviePersonalities;
}

export function getNumberOfTraitsMetadata(
  traits: TraitData[]
): number {
  return traits.length;
}

export function getNameSurnameKeywords(
  name: string,
  surname: string,
): string[] {
  const res: string[] = [];
  const name_surname = name.toLowerCase() + ' ' + surname.toLowerCase();
  const surname_name = surname.toLowerCase() + ' ' + name.toLowerCase();
  const nameSurnameLength = name_surname.length;
  for (let i = 1; i <= nameSurnameLength; ++i) {
    const nameSurnamePartial = NAME_KEYWORD_PREFIX + name_surname.slice(0, i);
    const surnameNamePartial = SURNAME_KEYWORD_PREFIX + surname_name.slice(0, i);
    res.push(nameSurnamePartial);
    res.push(surnameNamePartial);
  }
  return res;
}

// TODO: IMPLEMENTARE
export function handleCloudFunctionResponse() {

}

export function adjustBillingCicleName(cycleName:string){
  switch(cycleName){
    case "year":
    return "Annuale"
    case "month":
    return "Mensile"
    default:
      return "Nessuno"
  }
}
export function adjustBillingName(cycleName:string){
  switch(cycleName){
    case "year":
    return "Abbonamento Annuale"
    case "month":
    return "Abbonamento Mensile"
    case "test":
      return "Periodo di Prova"
    default:
      return "Nessuno"
  }
}

export function adjustSubscriptionStatusCileName(subStatus:string){
  switch(subStatus){
    case "active":
      return "Attivo"
    case "inactive":
      return "inattivo"
    case "ended":
      return "Scaduto"
    default:
      return "inattivo"
  }
}

export function areAllNotEmpty(elements:string[]): boolean {
  return elements.every((element) => element !== "");
}

export function setSubscriptionTypesString(element:string): SubsctiptionType{
  switch (element){
    case"Semestrale":
    return "sixMonth"
    case"Annuale":
    return "year"
    case"Mensile":
    return "month"
    default:
      return "month"
  }
}

export function capitalizeFirstLetter(text:string):string{
  return text.slice(0,1).toUpperCase()+text.slice(1)
}

export async function createPdfToExport(uid: string, calculationResult:Calculation){
  let startDocumnety=10
  const startDocumnetx=10;
  const family = await getUserFamily(uid, calculationResult.familyId);
  const caregiver = await getUserCaregiver(uid, calculationResult.caregiverId);
  const doc = new jsPDF();
  doc.addImage(logo,"PNG",startDocumnetx,startDocumnety,80,20)
  doc.setFontSize(10); 
  doc.text(`Report di ${family.personalData.name} ${family.personalData.surname}`, startDocumnetx+140, startDocumnety+9);
  doc.text(`Colloquio, ${formatDate(calculationResult.tsCreated)}`, startDocumnetx+140, startDocumnety+14);
  doc.setFontSize(12); 
  
  const calculationText= getCalculationResultRange(calculationResult.result)+" "+ calculationResult.result.toFixed(2)+"%"
  doc.text("Esito Compatibilità: "+calculationText, startDocumnetx, startDocumnety+40);

// family body

  const requiredCoverageText = CAREGIVER_COVERAGE_AVAILABILITY.find(el => el.key === family.personalData.coverage)?.value ?? '';
  const weekendNeedsValue = family.usefulInfo.find(el => el.name === 'Bisogno nei weekend')?.value ?? '';
  const nightSleepValue = family.usefulInfo.find(el => el.name === 'Di notte dorme')?.value ?? '';
  const smokeAcceptanceValue = family.usefulInfo.find(el => el.name === 'Accettereste una persona fumatrice')?.value ?? '';
  const otherPeoplePresenceValue = family.usefulInfo.find(el => el.name === 'Presenza di altri familiari in casa')?.value ?? '';
  const surveilanceCameraValue = family.usefulInfo.find(el => el.name === 'Presenza di telecamere di sorveglianza')?.value ?? '';
  const caregiverRoomPresenceValue = family.usefulInfo.find(el => el.name === "C'è la stanza per la badante")?.value ?? '';

  const familyTableBody=[
    [
      { 
        content: "Dati Famiglia", 
        styles: {halign:"center",fontStyle: "bold", fillColor: [154, 236, 237], textColor: [0, 0, 0] }, 
        colSpan: 2
      },   
    ] as RowInput,
    ["Nome",family.personalData.name],
    ["Cognome",family.personalData.surname],
    ["Numero Di Telefono",family.personalData.telephone],
    ["Indirizzo",family.personalData.address],
    ["Copertura richiesta", requiredCoverageText],
    ["Nazionalità",family.excludedNationalities],
    ["Data Di Nascita",formaTimestampTo_DD_MM_YY(family.personalData.tsDateOfBirth)],
    ["Stanza per badante", caregiverRoomPresenceValue],
    ["Di notte dorme", nightSleepValue],
    ["Bisogno nel weekend", weekendNeedsValue],
    ["Peso (kg)",family.personalData.weight],
    ["Altezza (cm)",family.personalData.height],
    ["Presenza Telecamere sorveglianza", surveilanceCameraValue],
    ["Accetta persona fumatrice", smokeAcceptanceValue],
    ["Presenza familiari in casa", otherPeoplePresenceValue],
    [
      { 
        content: "Caratteristiche famiglia", 
        styles: {halign:"center",fontStyle: "bold", fillColor: [154, 236, 237], textColor: [0, 0, 0] }, 
        colSpan: 2
      },
    ]as RowInput,
  ]
  
  if(family.traits.length>0){
    family.traits.forEach((elem)=>{
      familyTableBody.push([String(elem.trait),elem.note && elem.note.length > 0 ? elem.note : 'Nessuna nota'])
    })
  }else familyTableBody.push([{ 
    content: "Nessuna conoscenza inserita", 
    styles: {halign:"center",  textColor: [0, 0, 0] }, 
    colSpan: 2
  }])

  familyTableBody.push([
    { 
      content: "Carattere famiglia", 
      styles: {halign:"center",fontStyle: "bold", fillColor: [154, 236, 237], textColor: [0, 0, 0] }, 
      colSpan: 2
    },    
  ],)
  if(family.personalities.length>0){
    family.personalities.forEach((elem)=>{
       familyTableBody.push([String(elem),""])
     })
  }else familyTableBody.push([{ 
    content: "Nessun Carattere inserito", 
    styles: {halign:"center",  textColor: [0, 0, 0] }, 
    colSpan: 2
  }])

    
// Caregivers Body

  const smokesText = CAREGIVER_SMOKES.find(el => el.key === caregiver.smokes)?.value ?? '';
  const otherPeoplePresenceText = CAREGIVER_OTHER_PEOPLE_PRESENCE.find(el => el.key === caregiver.otherPeoplePresence)?.value ?? '';
  const nightTimeText = CAREGIVERS_NIGHT_TIME.find(el => el.key === caregiver.nightTime)?.value ?? '';
  const weekendAvailabilityText = CAREGIVER_WEEKEND_AVAILABILIY.find(el => el.key === caregiver.weekendAvailability)?.value ?? '';
  const coverageText = CAREGIVER_COVERAGE_AVAILABILITY.find(el => el.key === caregiver.personalData.coverageAvailability)?.value ?? '';
  const caregiverTableBody=[
    [
      { 
        content: "Dati badante", 
        styles: {halign:"center",fontStyle: "bold", fillColor: [154, 236, 237], textColor: [0, 0, 0] }, 
        colSpan: 2
      }, 
      
    ]as RowInput,
    ["Nome",caregiver.personalData.name],
    ["Cognome",caregiver.personalData.surname],
    ["Indirizzo",caregiver.personalData.address],
    ["Numero Di Telefono",caregiver.personalData.telephone],
    ["Distanza (km)",calculationResult.distance??"0"],
    ["Disponibilità di copertura", coverageText],
    ["Nazionalità",caregiver.personalData.nationality],
    ["Data Di Nascita",formaTimestampTo_DD_MM_YY(caregiver.personalData.tsDateOfBirth)],
    ["Conoscenza italiano",caregiver.languageKnowledge],
    ["Disp. alzarsi la notte", nightTimeText],
    ["Disp. lavoro nel weekend", weekendAvailabilityText],
    ["Anni di esperienza",caregiver.yearsOfExperience],
    ["Referenze",caregiver.personalData.references ? 'Sì' : 'No'],
    ["Conoscenza cucina",caregiver.coockingKnowledge],
    ["Fuma", smokesText],
    ["Disp. lavoro con altre persone",otherPeoplePresenceText],
    [
      { 
        content: "Conoscenze badante", 
        styles: {halign:"center",fontStyle: "bold", fillColor: [154, 236, 237], textColor: [0, 0, 0] }, 
        colSpan: 2
      },   
    ]as RowInput,
  ]
 
  if(caregiver.traits.length>0){
    caregiver.traits.forEach((elem)=>{
      if(elem.on)caregiverTableBody.push([String(elem.trait), elem.note && elem.note.length > 0 ? elem.note : 'Nessuna nota'])
    })
  }else familyTableBody.push([{ 
    content: "Nessuna conoscenza inserita", 
    styles: {halign:"center",  textColor: [0, 0, 0] }, 
    colSpan: 2
  }])

  caregiverTableBody.push([
    { 
      content: "Carattere badante", 
      styles: {halign:"center",fontStyle: "bold", fillColor: [154, 236, 237], textColor: [0, 0, 0] }, 
      colSpan: 2
    }
  ],)

  if(caregiver.personalities.length>0){
    caregiver.personalities.forEach((elem)=>{
      caregiverTableBody.push([String(elem),""])
    })
  }else familyTableBody.push([{ 
    content: "Nessun Carattere inserito", 
    styles: {halign:"center",  textColor: [0, 0, 0] }, 
    colSpan: 2
  }])

  

  autoTable(doc, {
    body: familyTableBody,
    startY: startDocumnety+50,
    theme: "grid",
    tableWidth:90,
    margin: { left: 10 } 
  });
  const familyTableFinalY = (doc as jsPDF & { lastAutoTable: { finalY: number } }).lastAutoTable.finalY + 10;

  if(doc.getNumberOfPages()>1){
    doc.setPage(1)
  }
  autoTable(doc, {
    body: caregiverTableBody,
    startY: startDocumnety+50,
    theme: "grid",
    tableWidth:90,
    margin: { left: 105 } ,
  });
  //const caregiverTableFinalY = (doc as jsPDF & { lastAutoTable: { finalY: number } }).lastAutoTable.finalY + 10;

  // Nuova pagina per le note e referenze
  doc.addPage();
  if(doc.getNumberOfPages()>1){
    doc.setPage(doc.getNumberOfPages())
  }

  // note Caregivers
  let finalY = 0;
  /* if(doc.getNumberOfPages()>1)finalY = familyTableFinalY>caregiverTableFinalY?caregiverTableFinalY:familyTableFinalY
  else finalY = familyTableFinalY>caregiverTableFinalY?familyTableFinalY:caregiverTableFinalY
  doc.text("Note badante:",startDocumnetx,finalY);
  const notes=caregiver.notes */

  // const textTest="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit accusamus perferendis impedit quisquam magni. Facilis asperiores cupiditate cum. Quis quidem quo dolorum, quaerat tempora doloribus facilis a voluptas dolor eos Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quaerat inventore voluptates aperiam. Placeat quasi, doloribus, culpa impedit ipsam error, earum nisi consectetur voluptate voluptatibus eaque harum blanditiis molestias! Adipisci, facilis?          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Commodi dolor reprehenderit ad dolore rem minus cupiditate voluptatem quidem dicta? Nisi vitae atque, neque itaque porro hic sunt soluta? Amet, quos.          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Libero, cumque excepturi inventore iste aperiam doloribus voluptas nostrum corporis cum deleniti odio numquam suscipit eligendi molestiae asperiores dolores vitae odit fugit!          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vitae numquam eos blanditiis, quibusdam tempore doloremque aut. Debitis laborum quibusdam minima! Enim voluptatibus deserunt nostrum nisi. Cumque dolorem adipisci animi sit?          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Placeat, fuga doloribus, eaque ipsum maxime magnam, sit perspiciatis quam dolorem facilis animi. Illum quam, quas beatae molestias voluptas corporis fugiat iste.          Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic perferendis repudiandae obcaecati blanditiis totam quasi a ut. Maiores debitis error ratione fugit reiciendis? Quae architecto accusantium officia, commodi numquam eius."
  let startY=finalY+10
  const pageHeight = doc.internal.pageSize.height; 
  const lineHeight = 5; 

  const refNumbersAndNotes = `NUMERI PER REFERENZE
  ${caregiver.referencesNumbers === '' ? 'Nessun numero per referenze' : caregiver.referencesNumbers}

  NOTE
  ${caregiver.notes === '' ? 'Nessuna nota' : caregiver.notes}`;

  const wrappedText2 = doc.splitTextToSize(refNumbersAndNotes, 180); 

  doc.setFontSize(8);
  addTextWithPageBreak(wrappedText2,startY,lineHeight,pageHeight,doc)
  doc.save("report.pdf");
}




function addTextWithPageBreak(wrappedText:string, startY:number, lineHeight:number,pageHeight:number,doc:any) {
  let currentY = startY;
  for (let i = 0; i < wrappedText.length; i++) {
    const textHeight = lineHeight; 
    if (currentY + textHeight > pageHeight - 20) {
      doc.addPage()
      currentY = 20
    }
    doc.text(wrappedText[i], 10, currentY);
    currentY += textHeight
  }
}
